import { getInitialVariableValue } from './getInitialVariableValue';

export const getTemplateVariablesValues = template =>
  (template.document.data.variables || []).reduce((prev, variable) => {
    if (variable.type === 'conditional') {
      return prev;
    }

    const initialValue = getInitialVariableValue(variable);

    return {
      ...prev,
      [variable.name]: initialValue,
    };
  }, {});
